import type { WarrantyConfig } from '#types/config/components/form/warranty'

export default {
  hasMerchandiseCredit: false,
  maxFiles: 6,
  productDamageOptions: {
    description: [
      { value: 'Color migration/bleeding', label: 'bleeding' },
      { value: 'Broken eyelets', label: 'brokenEyelets' },
      { value: 'Delamination', label: 'delamination' },
      { value: 'Peeling', label: 'peeling' },
      { value: 'Seam/Stitching failure', label: 'seamFailure' },
      { value: 'Sole Crumbling', label: 'soleCrumbling' },
      { value: 'Sole Separation', label: 'soleSeparation' },
      { value: 'Squeaking', label: 'squeaking' },
      { value: 'Fraying/Tear', label: 'tear' },
      { value: 'Waterproof failure', label: 'waterproofFailure' },
      { value: 'Other', label: 'other' }
    ],
    place: [
      { value: 'Collar', label: 'collar' },
      { value: 'Eyelets', label: 'eyelets' },
      { value: 'Heel', label: 'heel' },
      { value: 'Inner Lining', label: 'innerLining' },
      { value: 'Sole', label: 'sole' },
      { value: 'Toe', label: 'toe' },
      { value: 'Other', label: 'other' }
    ]
  },
  styleNumberHintImage: 'https://assets.timberland.com/image/upload/v1757592138/style-number'
} satisfies WarrantyConfig
